/**
 * @author Yaochao
 * @date 2021/7/9 19:02
 * @description search中dateRange组件封装
 */
import React, {useEffect, useState} from "react";
import {DatePicker} from "antd";

const {RangePicker} = DatePicker;

/**
 *
 * @param title 文本内容
 * @param valueKey value的key
 * @param setSearchParams 父组件传递，无需设置
 * @param resetFlag 父组件传递，无需设置
 * @returns {*}
 * @constructor
 */
export const ZkDateRange = (props) => {
    const {title: title, valueKey: valueKey, setSearchParams: setSearchParams, setDefaultSearchParams: setDefaultSearchParams, resetKeys: resetKeys} = props;
    const [value, setValue] = useState([]);

    /**
     * value值变化处理，并把值通过setSearchParams传递给父组件
     * @param val
     */
    useEffect(()=>{
        if(props.defaultValue && props.defaultValue.length ==2){
            if((props.defaultValue[0] !='' && props.defaultValue[0] != undefined) && (props.defaultValue[1]!='' && props.defaultValue[1]!= undefined)){
                let arr = [moment(props.defaultValue[0]),moment(props.defaultValue[1])]
                onChange(arr)
            }
        }

    },[props.defaultValue])
    function onChange(date) {
        if (valueKey) {
            if (date && date.length == 2) {
                let begin = date[0].valueOf();
                let end = date[1].valueOf();
                let val = [begin, end];
                setSearchParams({[valueKey]: val});
                setValue(date);
            } else {
                setSearchParams({[valueKey]: undefined});
                setValue(date);
            }
        }
    }

    /**
     * 向group传递默认值
     */
    useEffect(() => {
        if (valueKey) {
            setDefaultSearchParams({[valueKey]: []});
        }
    }, []);

    useEffect(() => {
        if (resetKeys.indexOf(valueKey) != -1) {
            setValue([])
        }
    }, [resetKeys]);

    return (
        <li className='sg-item'>
            <label className='sg-item-title'>{title}</label>
            <div className='sg-item-wraper dateRange'>
                <RangePicker showTime={{format: 'HH:mm'}}
                             format="YYYY-MM-DD HH:mm"
                             onChange={onChange}
                             getPopupContainer={triggerNode => triggerNode.parentNode}
                             value={value}/>
            </div>
        </li>
    )
};

export default ZkDateRange
